import { components as c } from "@/components";
import ProductForm from "@/features/events/features/products/components/ProductForm";
import { useDiaryByIdQuery } from "@/features/diaries";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const ProductFormPage = () => {
    const { eventId, diaryId, productId } = Route.useParams();
    const { data: diary } = useDiaryByIdQuery(diaryId);
    const navigate = useNavigate();
    const event = diary?.events_view?.find((e) => e.event_id === eventId);
    const product = event?.products_view?.[0];

    return (
        <ProductForm
            diaryId={diaryId}
            eventId={eventId}
            productId={productId}
            organisationId={diary?.organisation_id as string}
            product={product}
            onSuccess={() =>
                navigate({
                    to: "/templates/diary/$diaryId/events/$eventId/complete",
                    params: { diaryId, eventId },
                })
            }
        />
    );
};

export const Route = createFileRoute("/_app/templates/diary/$diaryId/events/$eventId/product/$productId/")({
    component: ProductFormPage,
});
